import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";

export class AirTimeRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrier?: Array<string>;
  code?: string;
  created?: Record<string, unknown>[];
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  toDate?: string;
  store?: Array<string>;
  staff?: Array<string>;
  isOnlyStore?: string;
  order?: string;

  constructor(data?: {
    carrier?: Array<string>;
    code?: string;
    created?: Record<string, unknown>[];
    fromDate?: string;
    limit?: number;
    page?: number;
    pagination?: boolean;
    phoneNumber?: string;
    status?: number;
    toDate?: string;
    store?: Array<string>;
    staff?: Array<string>;
    isOnlyStore?: string;
    order?: string;
  }) {
    super();
    this.carrier = data?.carrier;
    this.code = data?.code;
    this.created = data?.created;
    this.fromDate = data?.fromDate;
    this.limit = data?.limit;
    this.page = data?.page;
    this.pagination = data?.pagination;
    this.phoneNumber = data?.phoneNumber;
    this.status = data?.status;
    this.toDate = data?.toDate;
    this.store = data?.store;
    this.staff = data?.staff;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
  }
}
